module.exports = __webpack_public_path__ + "img/11.73cd51d8.jpg";